import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CloseButton } from 'secondstep-components'

export const StyledCloseButton = styled(CloseButton)`
  && {
    display: flex;
    align-self: flex-end;
    z-index: 210;
    font-weight: 400;
    padding: 0;
    right: 1.25rem;
    top: 1.25rem;

    svg {
      min-width: 13px;
      min-height: 13px;
      color: ${themeGet('colors.gray1200')};
    }
  }
`
